/* eslint-disable */

import _ from 'lodash';
import * as constants from './constants';
import {
  ONBOARDING_STEP_CREATE,
  ONBOARDING_STEP_BUYING_CRITERIA,
} from './constants';

export const validateOnboarding = (params, step, isMarketplace) => {
  const {
    organizationName,
    phoneNumber,
    entityName,
    buyingStrategy,
    buyingVolume,
    ownedVolume,
    currentGoal,
    currentGoalExplanation,
    buyBoxList,
  } = params;
  const validationObj = {
    areas: '',
  };
  switch (step) {
    case ONBOARDING_STEP_CREATE:
      if (organizationName?.length < 3) {
        validationObj.organizationName = 'Required. At least 3 letters';
      }
      if (entityName?.length < 3) {
        validationObj.entityName = 'Required. At least 3 letters';
      }
      break;
    case ONBOARDING_STEP_BUYING_CRITERIA:
      if (
        (currentGoal === 'grow_portfolio' || currentGoal === 'browsing') &&
        !buyingVolume
      ) {
        validationObj.buyingVolume = 'Required';
      }
      if (!buyingStrategy.length) {
        validationObj.buyingStrategy = 'Required';
      }
      if (ownedVolume == null || ownedVolume === '') {
        validationObj.ownedVolume = 'Required';
      }
      if (!currentGoal) {
        validationObj.currentGoal = 'Required';
      }
      if (currentGoal && !currentGoalExplanation.length) {
        validationObj.currentGoalExplanation = 'Required';
      }
      break;
    case constants.ONBOARDING_STEP_PHONE:
      if (phoneNumber?.number?.length !== 10) {
        validationObj.phoneNumber = 'Fill the best number to reach you at';
      }
    case constants.ONBOARDING_STEP_BUYBOX:
      if (
        !buyBoxList.every(
          (buybox) =>
            buybox.areas.length > 0 &&
            buybox.priceRange[1] &&
            buybox.yearBuiltRange[0],
        )
      ) {
        validationObj.buyBoxList =
          'Please add at least one market to continue. All fields are required.';
      }
      break;
    default:
      break;
  }

  return {
    isValid:
      Object.values(validationObj).filter((x) => x.length > 0).length === 0,
    validationObj,
  };
};

export const getStepParams = (currentStepKey, params) => {
  switch (currentStepKey) {
    case constants.ONBOARDING_STEP_CREATE:
      return _.pick(params, [
        'organizationName',
        'numOfDealsQuestion',
        'mainInterestQuestion',
      ]);
    case constants.ONBOARDING_STEP_BUYING_CRITERIA:
      return _.pick(params, [
        'buyingVolume',
        'buyingStrategy',
        'ownedVolume',
        'currentGoal',
        'currentGoalExplanation',
      ]);
    case constants.ONBOARDING_STEP_PHONE:
      return _.pick(params, ['phoneNumber']);
    case constants.ONBOARDING_STEP_BUYBOX:
      return _.pick(params, ['buyBoxList']);
    default:
      return {};
  }
};

export const getAreasLongString = (buyBoxList) => {
  if (
    !buyBoxList ||
    buyBoxList.length === 0 ||
    !buyBoxList[0].areas ||
    buyBoxList[0].areas.length === 0
  )
    return '';
  const { areas } = buyBoxList[0];

  let areasString = areas.map((area) => area?.state).filter((area) => !!area);

  areasString = _.uniq(areasString);
  areasString.map((area) => area.toLowerCase()).join(',');

  return areasString;
};
